var _defs, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsBaseball = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00a000;stroke-width:2px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.258 8.51c-.218-.29-.362-.576-.628-.844-2.662-2.68-8 1.01-9.8 3.3-1.374 1.746-3.44 7.155-5.483 7.642-.914.218-1.756-1.293-2.128-1.982-3.368-6.231.796-13.92 7.825-14.596 4.454-.428 8.756 2.237 10.214 6.48Z",
    className: "cls-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.994,
    cy: 12.019,
    r: 9.971,
    className: "cls-1"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsBaseball);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icons_baseball_.e4bea7738ac79864a0abd568a3bffea6.svg";